import { Page } from 'directFlow/types'

interface Params {
  quoteId: string | undefined
  pathUtil: (page: Page) => string
  isQuoteCompleted: boolean
  isDirectLead: boolean
  startPath?: string
}

export function createRedirectPath({
  quoteId,
  pathUtil,
  isQuoteCompleted,
  isDirectLead,
  startPath,
}: Params): string {
  if (startPath) {
    return startPath
  } else if (isQuoteCompleted) {
    return `/quote/${quoteId}/continue-quote`
  } else if (isDirectLead) {
    return `/direct/${quoteId}/save-for-later`
  } else {
    return pathUtil(Page.REGISTRATION)
  }
}
